<template>
  <Cell
    class="cell-text"
    :class="{ expanded, preLabel }"
    :editable="editable"
    :error="err"
    :error-position="errorPosition"
    @mouseover.native="mouseOver"
    @mouseout.native="mouseOut"
    @keydown.native.enter.prevent="enter"
    @keydown.native.esc.prevent.stop="goBack"
    @contextmenu="(e) => $emit('contextmenu', e)"
  >
    <div v-if="$slots.pre" contenteditable="false" class="d-contents">
      <slot name="pre" />
    </div>

    <div
      ref="content"
      :class="[classname, 'cell-text-content', { 'text-ellipsis': !expanded }]"
      :contenteditable="editable"
      @click="click"
      @focus="select"
      @input="input"
      @blur="blur"
    >
      {{ val }}
    </div>

    <!--    TODO: удалять или не удалять-->
    <!--    <div v-if="preLabel && !expanded" contenteditable="false">{{ preLabel }}&nbsp;</div>-->

    <div v-if="$slots.after" class="cell_after" contenteditable="false">
      <slot name="after" />
    </div>
  </Cell>
</template>

<script>
  import Cell from '@/components/common/Cell';

  export default {
    name: 'TextCell',
    components: { Cell },
    props: {
      label: {
        type: String,
        default: '',
      },

      preLabel: {
        type: String,
        default: '',
      },

      editable: {
        type: Boolean,
        default: false,
      },

      classname: {
        type: String,
        default: '',
      },

      error: {
        type: String,
        default: '',
      },

      errorPosition: {
        type: String,
        default: 'right', // left|right
      },
    },

    data() {
      return {
        focus: false,
        expanded: false,
        val: this.label,
        oldVal: null,
        err: this.error,
        clickedFocus: false,
      };
    },

    watch: {
      label(val) {
        this.val = val;
      },
      error(val) {
        this.err = val;
      },
    },

    methods: {
      // При наведении мышкой нужно показывать весь текст, но не
      // оставлять фокус, скрывая текст при уходе мыши
      mouseOver(e) {
        this.click(e, false);
      },
      mouseOut() {
        if (!this.clickedFocus) {
          this.blur();
        }
      },
      click(e, clickedFocusFlag = true) {
        if (!this.editable) return;

        if (!this.expanded) {
          this.expanded = true;
        } else {
          if (clickedFocusFlag) {
            this.clickedFocus = true;
          }
          this.$emit('click', e);
        }
      },
      select() {
        if (!this.editable) return;

        this.focus = true;
        this.oldVal = this.val.trim();

        // TODO: надо?
        // let range = document.createRange();
        // range.selectNodeContents(e.target.firstChild);
        // let selection = window.getSelection();
        // selection.removeAllRanges();
        // selection.addRange(range);
      },
      input() {
        this.err = '';
      },
      blur(e) {
        if (this.clickedFocus) {
          this.clickedFocus = false;
        }
        this.focus = false;
        this.expanded = false;
        const firstChild = e?.target.firstChild;
        const val = firstChild?.textContent.trim();
        if (firstChild && val !== this.val) {
          this.val = val;
          this.$emit('change', { event: e, value: val, oldVal: this.oldVal });
        }
      },
      enter(e) {
        this.focus = false;
        e.target.blur();
      },
      goBack(e) {
        if (this.oldVal) {
          e.target.firstChild.textContent = this.oldVal;
          this.val = this.oldVal;
        }
        this.oldVal = null;
        e.target.blur();
      },
    },
  };
</script>
